import axios from 'axios';
import { createAuthHeaders } from '../api-client';
import { UserContextDto, ProgrammingExperience } from '@optidev/shared-types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface UserProfile {
  role?: string;
  department?: string;
  programmingExperience?: ProgrammingExperience;
  usageIntent?: string;
}

export const usersApi = {
  /**
   * Get current user's profile (returns {} if not completed onboarding)
   */
  async getProfile(token: string): Promise<UserProfile> {
    const response = await axios.get(`${API_URL}/api/users/me/profile`, {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },

  /**
   * Update current user's profile
   */
  async updateProfile(token: string, profile: UserContextDto): Promise<UserProfile> {
    const response = await axios.patch(`${API_URL}/api/users/me/profile`, profile, {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },
};
